import { defineMessages } from '@jutro/locale';

export default defineMessages({
    viewAllRenewals: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.VIEW ALL RENEWALS',
        defaultMessage: 'VIEW ALL RENEWALS'
    },
    noRecentPolicyRenewalsFound: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.No recent policy renewals found',
        defaultMessage: 'No recent policy renewals found'
    },
    renewalDate: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.RENEWAL DATE',
        defaultMessage: 'RENEWAL DATE'
    },
    customerName: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    product: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policy: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.POLICY #',
        defaultMessage: 'POLICY #'
    },
    current: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.CURRENT',
        defaultMessage: 'CURRENT'
    },
    new: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.NEW',
        defaultMessage: 'NEW'
    },
    change: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.CHANGE',
        defaultMessage: 'CHANGE'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    Renewals: {
        id: 'ml.gateway.views.ActivityReports.MLRenewalsReportComponent.Renewals...',
        defaultMessage: 'Renewals...'
    }
});
